import { ReputationManagementConstants } from "../../../../constants/Network/reputationManagement.constants";

const initialState = {
    fetching: false,
    listData: null,
    listDataError: false,

    syncFetching: false,
    syncData: null,
    syncError: false,

    reviewFetching: false,
    reviewData: null,
    reviewError: false,

    reviewStatisticsFetching: false,
    reviewStatisticsData: null,
    reviewStatisticsError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        // LIST actions
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_LIST_PENDING:
            return {
                ...state,
                fetching: true,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_LIST_FULFILLED:
            return {
                ...state,
                fetching: false,
                listDataError: false,
                listData: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_LIST_REJECTED:
            return {
                ...state,
                fetching: false,
                listDataError: action.payload
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_LIST_CLEAR:
            return {
                ...state,
                listData: null,
                listDataError: false,
            };

        // SYNC actions
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_SYNC_PENDING:
            return {
                ...state,
                syncFetching: true,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_SYNC_FULFILLED:
            return {
                ...state,
                syncFetching: false,
                syncError: false,
                syncData: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_SYNC_REJECTED:
            return {
                ...state,
                syncFetching: false,
                syncError: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_SYNC_CLEAR:
            return {
                ...state,
                syncData: null,
                syncError: false,
            };

        // REVIEW actions
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_PENDING:
            return {
                ...state,
                reviewFetching: true,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_FULFILLED:
            return {
                ...state,
                reviewFetching: false,
                reviewError: false,
                reviewData: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_REJECTED:
            return {
                ...state,
                reviewFetching: false,
                reviewError: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_CLEAR:
            return {
                ...state,
                reviewData: null,
                reviewError: false,
            };

        // REVIEW STATISTICS actions
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_STATISTICS_PENDING:
            return {
                ...state,
                reviewStatisticsFetching: true,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_STATISTICS_FULFILLED:
            return {
                ...state,
                reviewStatisticsFetching: false,
                reviewStatisticsError: false,
                reviewStatisticsData: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_STATISTICS_REJECTED:
            return {
                ...state,
                reviewStatisticsFetching: false,
                reviewStatisticsError: action.payload,
            };
        case ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_STATISTICS_CLEAR:
            return {
                ...state,
                reviewStatisticsData: null,
                reviewStatisticsError: false,
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            };
        default:
            return state;
    }
}